const productsArray = [
  {
    id: "price_1TlqMu2LbtZGIEzvdc08Elj0",
    title: "Life Drawing Event Ticket",
    price: 15,
  },

  // {
  //   id: "prod_UiQciVS3g9pY55",
  //   title: "Test",
  //   price: 999,
  // },
];

function getProductData(id) {
  let productData = productsArray.find((product) => product.id === id);

  if (productData === undefined) {
    console.log("Product data does not exist for ID: " + id);
    return undefined;
  }

  return productData;
}

export { productsArray, getProductData };
